import RfmSectionsTabs from "./rfm-section-tabs";
import VidUploader from "./rfm-section-tabs/vid-uploader";
import ImgUploader from "./rfm-section-tabs/img-uploader";

const ReviewFormMedia = ({ setNoteDetails }) => {
  const tabs = [
    {
      label: "Post a video",
      content: <VidUploader setNoteDetails={setNoteDetails} />,
    },
    {
      label: "Post photos",
      content: <ImgUploader setNoteDetails={setNoteDetails} />,
    },
  ];
  return (
    <div className="w-full h-full flex items-center justify-center mb-20">
      <RfmSectionsTabs tabs={tabs} setNoteDetails={setNoteDetails} />
    </div>
  );
};

export default ReviewFormMedia;
